import type {
  AppRouter, NavigateArgs,
} from './types';

function NavigationService(...args: NavigateArgs) {
  return NavigationService.router?.navigate(...args);
}

NavigationService.router = undefined as AppRouter | undefined;

NavigationService.setRouter = (router: AppRouter): void => {
  NavigationService.router = router;
};

export default NavigationService;
